// banner 视频链接
export const youtubeMap: Record<string, string> = {
    us: 'https://www.youtube.com/embed/LaxudAGU9BM',
    jp: 'https://www.youtube.com/embed/3qHyojQYVYw',
    kr: 'https://www.youtube.com/embed/rF2CEo9Wz4s',
    it: 'https://www.youtube.com/embed/3iUw9QuMKyE',
    de: 'https://www.youtube.com/embed/hTyH-iYCQMw',
    fr: 'https://www.youtube.com/embed/ub8svvZppdo',
    es: 'https://www.youtube.com/embed/riu5xiyiPbc',
};

// 时间线&任务shopify跳转链接
export const shopnowMay: Record<string, string> = {
    za: 'https://za.ecoflow.com/pages/easter-members-festival',
};
